import { EVENT_EDIT_DETAILS_ROUTE, EVENT_REPORT_ROUTE } from '@constants/routes';
import type { MagicSearchEvent } from '@domain/magic-search';
import type { CompanyClubRoute } from '@hooks/use-open-company-club-route';

// The same pages the events list opens; `useEventNavigation` itself is tied to a list view and one company.
export const getEventRoute = ({
  id,
  isPublished,
  isNavigable,
  club,
  company,
}: MagicSearchEvent): CompanyClubRoute | null => {
  const clubSlug = club?.slug;
  if (!isNavigable || !clubSlug || !company) return null;
  const companyLegacyId = String(company.legacyId);
  const route = isPublished ? EVENT_REPORT_ROUTE : EVENT_EDIT_DETAILS_ROUTE;

  return {
    companyLegacyId,
    clubSlug,
    path: route.replace(':companyId', companyLegacyId).replace(':clubSlug', clubSlug).replace(':eventId', id),
  };
};
